module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/makeup@2x_c8e1e6.png";